/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Alert { 
    /**
     * Der Alert-Typ, bspw. MISSING_MAIL oder MISSING_SEPA
     */
    id?: string;
}

